import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { cn } from '../../../utils/classnames.js';
function AnimatedContent({ children, isHovered, animationTriggered, animateOnHover, className, }) {
    // Memoizing the content classes
    const contentClasses = useMemo(() => cn('ui-w-full', {
        'ui-animate-slide-out-down': animateOnHover && animationTriggered && isHovered,
        'ui-animate-slide-out-up': animateOnHover && animationTriggered && !isHovered,
    }), [animateOnHover, animationTriggered, isHovered]);
    // Memoizing the invisible content classes
    const invisibleContentClasses = useMemo(() => cn('ui-absolute ui-inset-0', {
        'ui-animate-slide-in-up': animateOnHover && animationTriggered && isHovered,
        'ui-animate-slide-in-down': animateOnHover && animationTriggered && !isHovered,
    }), [animateOnHover, animationTriggered, isHovered]);
    return (_jsxs("span", { className: "ui-relative ui-flex ui-w-full", children: [_jsx("span", { className: cn(contentClasses, className), children: children }), _jsx("span", { className: cn(invisibleContentClasses, className), children: children })] }));
}
export default AnimatedContent;
